export enum PreservationInterest {
  PRESERVE_SPERM = "PRESERVE_SPERM",
  PRESERVE_EGGS = "PRESERVE_EGGS",
  PRESERVE_EMBRYOS = "PRESERVE_EMBRYOS",
  PRESERVE_EGGS_EMBRYOS_OR_SPERM = "PRESERVE_EGGS_EMBRYOS_OR_SPERM"
}
